import { createContext, useContext, useState, useEffect } from "react";
import { dianaApi } from "../../services";

const PostsContext = createContext();

export const PostsProvider = ({ children }) => {
  const [posts, setPosts] = useState([]);
  const [postsLoad, setPostsLoad] = useState(true);
  const [showPost, setShowPost] = useState(false);
  const [degPostsCalc, setDegPostsCalc] = useState(0);
  const [actualPost, setActualPost] = useState({});
  const [firstLoad, setFirstLoad] = useState(false);

  const getActualPost = (postId) => {
    const post = posts.filter((elem) => elem.id === postId);
    setActualPost(post[0]);
    setShowPost(true);
  };

  const loadPosts = () => {
    dianaApi
      .get(`/posts?_embed&per_page=60`)
      .then((response) =>
        setPosts(
          response.data.sort((a, b) => (a.categories < b.categories ? 1 : -1))
        )
      )
      .then(() => setPostsLoad(false))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    setPostsLoad(true);
    loadPosts();
  }, []);

  useEffect(() => {
    if (posts.length > 0) {
      setDegPostsCalc(360 / posts.length);
    }
  }, [posts]);

  return (
    <PostsContext.Provider
      value={{
        posts,
        postsLoad,
        degPostsCalc,
        getActualPost,
        actualPost,
        showPost,
        setShowPost,
        firstLoad,
        setFirstLoad,
      }}
    >
      {children}
    </PostsContext.Provider>
  );
};

export const usePosts = () => useContext(PostsContext);
